// ===== DEBUG SWITCH =====
const GIFT_DEBUG = true;
const giftLog  = (...a) => GIFT_DEBUG && console.log('[GIFT]', ...a);
const giftWarn = (...a) => GIFT_DEBUG && console.warn('[GIFT]', ...a);
const giftErr  = (...a) => GIFT_DEBUG && console.error('[GIFT]', ...a);

// at file top (config)
const GIFT_CHECK_COOLDOWN_MS = 800;

window._giftNoticeOpen = window._giftNoticeOpen || false;


function getEligibleGiftsNotInCart() {
  // Safety checks
  if (!window.FREE_GIFTS || !Array.isArray(window.FREE_GIFTS)) {
    console.warn("FREE_GIFTS not found");
    return Promise.resolve({
      missingGifts: [],
      subtotal: 0
    });
  }

  // Fetch the cart
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const subtotal = cart.total_price; // in cents

      // Filter eligible gifts that are NOT in the cart
      const missingGifts = window.FREE_GIFTS.filter(gift => {
        const meetsThreshold = subtotal >= gift.threshold;
        const inCart = cart.items.some(item => item.handle === gift.handle);
        return meetsThreshold && !inCart;
      });

      console.log("Eligible gifts NOT in cart:", missingGifts);
      // ⬅️ now returning both
      return { missingGifts, subtotal };
    })
    .catch(err => {
      console.error("Error checking eligible gifts:", err);
      return {
        missingGifts: [],
        subtotal: 0
      };
    });
}

function updateFreeGiftNote() {
  if (typeof getEligibleGiftsNotInCart !== 'function') {
    giftWarn && giftWarn('updateFreeGiftNote: getEligibleGiftsNotInCart missing');
    return;
  }

  getEligibleGiftsNotInCart()
    .then(function(result) {
      const banner     = document.getElementById('free-gift-banner');
      const note       = document.getElementById('free-gift-note');
      const missingGifts = result?.missingGifts || [];
      const subtotal     = result?.subtotal || 0; // cents

      // ---------- TOP BANNER TEXT (threshold progress) ----------
      if (banner) {
        const progressEl = banner.querySelector('[data-free-gift-progress]');

        if (progressEl) {
          
          // Read thresholds in the same order they are defined
          const t1 = window.FREE_GIFTS[0].threshold; // $75
          const t2 = window.FREE_GIFTS[1].threshold; // $150
          const t3 = window.FREE_GIFTS[2].threshold; // $250

          const fmt = cents => '$' + (cents / 100).toFixed(0);

          let msg;
          if (subtotal < t1) {
            // cart total < $75
            msg = `Spend ${fmt(t1)} to unlock a free gift!`;
          } else if (subtotal < t2) {
            // cart total > $75 & < $150
            msg = `You've unlocked 1 gift. Spend ${fmt(t2)} total for another gift!`;
          } else if (subtotal < t3) {
            // cart total > $150 & < $250
            msg = `You've unlocked 2 gifts. Spend ${fmt(t3)} total for another gift!`;
          } else {
            // cart total > $250
            msg = `Game on! You've unlocked all 3 gifts.`;
          }

          progressEl.textContent = msg;
          giftLog && giftLog('updateFreeGiftNote: banner message set:', msg);
        }
      } else {
        giftWarn && giftWarn('updateFreeGiftNote: #free-gift-banner not found');
      }

      // ---------- BOTTOM NOTE (existing behavior) ----------
      if (!note) {
        giftWarn && giftWarn('updateFreeGiftNote: #free-gift-note not found');
        return;
      }

      if (Array.isArray(missingGifts) && missingGifts.length > 0) {
        note.style.display = 'block';
        note.dataset.giftHandles = missingGifts
          .map(g => g.handle)
          .join(',');
        giftLog && giftLog(
          'updateFreeGiftNote: showing note for handles:',
          note.dataset.giftHandles
        );
      } else {
        note.style.display = 'none';
        note.dataset.giftHandles = '';
        giftLog && giftLog('updateFreeGiftNote: hiding note (no missing gifts)');
      }
    })
    .catch(function(err) {
      giftErr && giftErr('updateFreeGiftNote failed:', err);
    });
}


document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.updateFreeGiftNote === 'function') {
    giftLog('DOMContentLoaded → calling updateFreeGiftNote()');
    updateFreeGiftNote();
  } else {
    giftWarn('updateFreeGiftNote not defined on DOMContentLoaded');
  }
});

// one-time "unlocked" notice guard (per session)
function hasSeenNotice() { return localStorage.getItem('gift_notice_shown') === '1'; }
function markSeenNotice() { localStorage.setItem('gift_notice_shown', '1'); giftLog('Notice marked as seen'); }

// track active flow so we don't show the notice again mid-queue
window._giftFlowActive = window._giftFlowActive || false;

// ---------- session guards (show each gift once per session) ----------
function hasSeenGift(handle) {
  const seen = localStorage.getItem(`gift_shown_${handle}`) === '1';
  giftLog('hasSeenGift?', handle, seen);
  return seen;
}
function markSeenGift(handle) {
  giftLog('Marking gift seen:', handle);
  localStorage.setItem(`gift_shown_${handle}`, '1');
}
function markSeenGifts(gifts) {
  giftLog('Marking gifts seen (bulk):', gifts?.map(g => g.handle));
  gifts?.forEach(g => localStorage.setItem(`gift_shown_${g.handle}`, '1'));
}

function resetSeenGifts(handles) {
  if (!Array.isArray(handles) || handles.length === 0) {
    giftWarn('resetSeenGifts: no handles passed');
    return;
  }

  handles.forEach(handle => {
    const key = `gift_shown_${handle}`;
    localStorage.removeItem(key);
    giftLog('resetSeenGifts → cleared', key);
  });
}

// ---------- gift helpers ----------
function pickEligibleGifts(cart) {
  const total = cart?.total_price || 0;
  const list = (window.FREE_GIFTS || [])
    .filter(g => total >= g.threshold)
    .sort((a, b) => b.threshold - a.threshold);
  giftLog('pickEligibleGifts → total:', total, 'eligible:', list.map(g => `${g.handle}@${g.threshold}`));
  return list;
}


// ---------- optional "unlocked" notice (shown when 2+ gifts are eligible) ----------
function showUnlockedNotice(eligibleGifts, { onAccept, onDecline } = {}) {
  const count = eligibleGifts.length;
  giftLog('showUnlockedNotice called. count:', count);

  if (count <= 1) {
    giftLog('Skipping notice (count <= 1). Proceeding directly.');
    onAccept?.();
    return;
  }

  // mark the one-time notice as shown immediately
  markSeenNotice();
   window._giftNoticeOpen = true;

  let handled = false;

  const html = `
    <div style="position:relative; padding:24px; max-width:420px; background-color:white; border: 1px solid black;">
      
      <h3 style="margin:0 0 8px; color: black;">🎉A little extra for your game. You've unlocked ${count} gifts!</h3>
      <p style="margin:0 0 16px; line-height:1.5; color: black;">Pick your gifts one by one.</p>
      <div style="display:flex; gap:8px;">
      <button class="js-gift-decline btn-decline" style="flex:1; padding:10px 14px; color:black; background:transparent; border:1px solid #444; cursor:pointer;">
          No, Thanks
        </button>  
      <button class="btn-ok" style="flex:1; padding:10px 14px; color:black; background-color:#5CFFAD; cursor:pointer;">
          Claim Gifts
        </button>
        
      </div>
    </div>`;

  if (!window.basicLightbox) {
    giftErr('basicLightbox not found — cannot show notice.');
    // As a fallback, just accept and continue.
    onAccept?.();
    return;
  }

  const modal = basicLightbox.create(html, {
    onClose: () => {
      if (!handled) {
        handled = true;
        giftLog('Notice closed via outside click/ESC → Accept/continue queue');
        markSeenNotice();
        onAccept?.();
      }
    }
  });

  modal.show();
  giftLog('Notice shown');

  const root = modal.element();
  root.querySelector('.btn-ok')?.addEventListener('click', () => {
    if (!handled) {
      handled = true;
      giftLog('Notice → Claim Gifts clicked');
      try { modal.close(); } catch (e) { giftErr(e); }
      onAccept?.();
    }
  }, { once: true });

  root.querySelector('.btn-decline')?.addEventListener('click', () => {
    if (!handled) {
      handled = true;
      giftLog('Notice → No, Thanks clicked');
      try { modal.close(); } catch (e) { giftErr(e); }
      onDecline?.(eligibleGifts);
    }
  }, { once: true });

  root.querySelector('.notice-close')?.addEventListener('click', () => {
    if (!handled) {
      handled = true;
      giftLog('Notice close (×) clicked → Accept/continue');
      try { modal.close(); } catch (e) { giftErr(e); }
      onAccept?.();
    }
  }, { once: true });
}
// ---------- bind variant → image swapping inside a quick view root ----------
function bindGiftVariantImageSwap(rootEl) {
  if (!rootEl) {
    giftWarn('bindGiftVariantImageSwap: no rootEl');
    return;
  }

  const quickProduct = rootEl; // modal root from basicLightbox.create(node)
  const imgEl = quickProduct.querySelector('.product-images img');
  const imagesScript = quickProduct.querySelector('.product-images script[type="application/json"]');
  const productVariants = quickProduct.querySelector('product-variants');

  if (!imgEl) {
    giftWarn('bindGiftVariantImageSwap: no .product-images img found');
    return;
  }
  if (!imagesScript) {
    giftWarn('bindGiftVariantImageSwap: no variant image JSON <script> found');
    return;
  }
  if (!productVariants) {
    giftWarn('bindGiftVariantImageSwap: no <product-variants> element found');
    return;
  }

  let quickViewImages;
  try {
    quickViewImages = JSON.parse(imagesScript.textContent);
  } catch (e) {
    giftErr('bindGiftVariantImageSwap: failed to parse variant image JSON', e);
    return;
  }

  giftLog('bindGiftVariantImageSwap: bound. Available variant image keys:', Object.keys(quickViewImages));

  productVariants.addEventListener('VARIANT_CHANGE', (e) => {
    const variant = e.target.currentVariant;
    giftLog('Gift VARIANT_CHANGE fired with variant:', variant && variant.id);

    if (!variant) return;
    if (!variant.featured_media) {
      giftLog('Variant has no featured_media; nothing to swap');
      return;
    }
    const srcset = quickViewImages[variant.id];
    if (!srcset) {
      giftLog('No srcset found for variant id in quickViewImages:', variant.id);
      return;
    }

    imgEl.setAttribute('srcset', srcset);
  });
}

// ---------- modal opener (idempotent finish; always restores fetch/loading) ----------
window.openGiftQuickViewForUrl = function(productUrl, { onFinish } = {}) {
  giftLog('openGiftQuickViewForUrl called with:', productUrl);
  if (!productUrl) { giftWarn('No productUrl — aborting.'); return; }
  if (window._freeGiftQuickViewLoading) { giftWarn('Modal load already in progress — aborting.'); return; }
  window._freeGiftQuickViewLoading = true;

  const url = `${productUrl}${productUrl.includes('?') ? '&' : '?'}view=${window.FREE_GIFT_VIEW || 'quick-view-gift'}`;
  giftLog('Fetching quick view URL:', url);

  fetch(url)
    .then(r => r.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const node = doc.querySelector('#product-product-quick-view, #product-product-quick-view-gift');
      if (!node) {
        giftErr('Quick view node not found in response. Check your view selector.');
        window._freeGiftQuickViewLoading = false;
        return;
      }
      if (!window.basicLightbox) {
        giftErr('basicLightbox not found — cannot show gift modal.');
        window._freeGiftQuickViewLoading = false;
        return;
      }

      const originalFetch = window.fetch;
      let finished = false;  // ✅ ensure we finish only once

      const modal = basicLightbox.create(node, {
        onClose: () => {
          // If user closes (outside/ESC/close btn) and we haven't already finished via /cart/add
          if (!finished) finalize('closed');
        }
      });

      function finalize(reason) {
        if (finished) return;         // ✅ idempotent
        finished = true;
        giftLog('Finalizing modal with reason:', reason);
        try { window.fetch = originalFetch; } catch(e) { giftErr(e); }
        try { modal.close(); } catch(e) { /* already closed */ }
        window._freeGiftQuickViewLoading = false; // ✅ always release the loading lock
        try { onFinish?.(reason); } catch(e) { giftErr(e); }
      }

      modal.show();
      bindGiftVariantImageSwap(modal.element());

      const declineBtn = modal.element().querySelector('.js-gift-decline');
      if (declineBtn) {
        declineBtn.addEventListener('click', () => {
          giftLog && giftLog('Gift modal "No, Thanks" clicked');
          try { modal.close(); } catch (e) {}

          // ✅ After the modal flow finishes and we’ve marked the gift as seen,
          // refresh the sidecart note so it re-appears immediately.
          setTimeout(() => {
            if (typeof updateFreeGiftNote === 'function') {
              giftLog && giftLog('Calling updateFreeGiftNote after No, Thanks');
              updateFreeGiftNote();
            }
          }, 200); // small delay just to let queue/seen state settle
        }, { once: true });
      }
      giftLog('Gift modal shown');

      // Intercept fetch calls while modal is open to catch /cart/add
      window.fetch = function(resource, init) {
        const reqUrl = typeof resource === 'string' ? resource : resource?.url || '';
        const method = (init?.method || 'GET').toUpperCase();
        const result = originalFetch.apply(this, arguments);

        result.then(() => {
          if (reqUrl.includes('/cart/add') && method === 'POST') {
            
            giftLog('Detected /cart/add POST inside modal — finalizing (added)');
            // No need to call modal.close() directly; finalize() will close & clean up.
            setTimeout(() => finalize('added'), 200);
            
          }
        }).catch(giftErr);

        return result;
      };

      // Close button inside the quick view (if present) just closes; onClose -> finalize('closed')
      const closeBtn = modal.element().querySelector('.basicLightboxClose');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          giftLog('Gift modal close button clicked');
          try { modal.close(); } catch (e) { giftErr(e); }
        }, { once: true });
      } else {
        giftWarn('No .basicLightboxClose found inside gift modal markup.');
      }
    })
    .catch(err => {
      giftErr('Error fetching quick view:', err);
      window._freeGiftQuickViewLoading = false;
    });
};


// ---------- queue to ensure one popup at a time ----------
window._giftQueue = [];
window._giftModalOpen = false;

function enqueueGifts(gifts) {
  if (!Array.isArray(gifts) || gifts.length === 0) { giftWarn('enqueueGifts: nothing to enqueue'); return; }
  const existing = new Set(window._giftQueue.map(g => g.handle));
  const added = [];
  gifts.forEach(g => { if (!existing.has(g.handle)) { window._giftQueue.push(g); added.push(g.handle); } });
  giftLog('enqueueGifts → queued:', added, 'current queue:', window._giftQueue.map(g => g.handle));
}

function processGiftQueue() {
  if (window._giftModalOpen) { giftWarn('processGiftQueue: modal already open'); return; }
  const next = window._giftQueue.shift();
  giftLog('processGiftQueue → next:', next?.handle, 'queueLeft:', window._giftQueue.map(g => g.handle));
  if (!next) {
    window._giftFlowActive = false; // finished, allow future flows
    giftLog('Queue empty. Flow finished.');
    return;
  }

  window._giftModalOpen = true;
  markSeenGift(next.handle);
  window.openGiftQuickViewForUrl(next.productUrl, {
    onFinish: (how) => {
      giftLog('Gift modal finished:', next.handle, 'via:', how);
      // markSeenGift(next.handle); // mark seen whether added or closed
      if (how === 'added') {
    if (typeof window.updateFreeGiftNote === 'function') {
      giftLog('onFinish → calling updateFreeGiftNote() after gift add');
      try { updateFreeGiftNote(); } catch (e) { giftErr(e); }
    }
  }
      
      window._giftModalOpen = false;
      processGiftQueue();        // continue with next gift
    }
  });
}

// ---------- main checker (call after any cart update or on load) ----------
function checkGiftsAndMaybeOpen() {
  giftLog('checkGiftsAndMaybeOpen called');

  if (!Array.isArray(window.FREE_GIFTS) || window.FREE_GIFTS.length === 0) {
    giftWarn('No FREE_GIFTS configured — aborting.');
    return;
  }

  // Cooldown to prevent double-trigger from rapid cart updates
  const now = Date.now();
  const delta = now - (window._lastGiftCheckTs || 0);
  if (window._lastGiftCheckTs && delta < GIFT_CHECK_COOLDOWN_MS) {
    giftWarn('Cooldown active — skipping. Δms:', delta);
    return;
  }
  window._lastGiftCheckTs = now;
  giftLog('Cooldown passed. Fetching /cart.js');

  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      giftLog('Cart fetched:', {
        total_price: cart?.total_price,
        items_count: cart?.items?.length
      });

     

      // Build a set of handles currently in the cart
const cartHandles = new Set(
  (cart.items || []).map(item => item.handle).filter(Boolean)
);

// Only gifts that are:
// - eligible by threshold
// - NOT already seen
// - NOT already in the cart
const eligible = pickEligibleGifts(cart)
  .filter(g =>
    !hasSeenGift(g.handle) &&
    !cartHandles.has(g.handle)
  );

giftLog(
  'Eligible (unseen & not-in-cart) gifts:',
  eligible.map(g => g.handle)
);

if (eligible.length === 0) {
  giftWarn('No eligible unseen & not-in-cart gifts — nothing to do.');
  return;
}

// queue these gifts
enqueueGifts(eligible);


      // If we already showed the notice this session OR a flow is already running,
      // do not show the notice again — just process the queue.
      if (hasSeenNotice() || window._giftFlowActive) {
        giftLog('Notice already seen or flow active → skipping notice, processing queue.');
        if (!window._giftNoticeOpen) { 
        processGiftQueue();
    } else {
        giftLog('Queue paused: Notice is currently open.'); // Optional debugging
    }
        return;
      }

      // Start a new flow and show the notice ONCE per session
      window._giftFlowActive = true;
      giftLog('Starting flow. Showing notice once.');
      showUnlockedNotice(eligible, {
        onAccept: () => {
          giftLog('Notice accepted → processing queue');
          window._giftNoticeOpen = false;
          processGiftQueue();
        },
        onDecline: (declinedGifts) => {
          giftLog('Notice declined. Gifts:', declinedGifts.map(g => g.handle));
          markSeenGifts(declinedGifts);
          const declinedHandles = new Set(declinedGifts.map(g => g.handle));
          window._giftQueue = window._giftQueue.filter(g => !declinedHandles.has(g.handle));
          window._giftNoticeOpen = false;
          window._giftModalOpen = false;
          window._giftFlowActive = false;
          giftLog('Decline complete. Queue cleared for declined gifts. Flow reset.');
        }
      });
    })
    .catch(err => {
      giftErr('Failed to fetch /cart.js:', err);
    });
}

window.checkGiftsAndMaybeOpen = checkGiftsAndMaybeOpen;

// Initial sanity logs (optional)
giftLog('FREE_GIFT_VIEW:', window.FREE_GIFT_VIEW);
giftLog('FREE_GIFTS configured:', (window.FREE_GIFTS || []).map(g => `${g.handle}@${g.threshold}`));
giftLog('basicLightbox present?', !!window.basicLightbox);

// ---------- sidecart "Claim your free gifts" click handler ----------
document.addEventListener('click', function (e) {
  const link = e.target.closest('[data-free-gift-note-link]');
  if (!link) return;

  e.preventDefault();
  giftLog('Free gift note clicked');

  const note = document.getElementById('free-gift-note');
  if (!note) {
    giftWarn('free-gift-note element not found');
    return;
  }

  // Handles we stored earlier in triggerFreeGiftCheck:
  // note.dataset.giftHandles = "tennis-wristbands,jetpack-packing-cubes-small"
  const handles = (note.dataset.giftHandles || '')
    .split(',')
    .map(h => h.trim())
    .filter(Boolean);

  giftLog('Free gift note handles to reset:', handles);

  // 1️⃣ Reset seen state for those gifts (sessionStorage keys gift_shown_<handle>)
  if (handles.length) {
    resetSeenGifts(handles);
  }
  markSeenNotice();
  // 2️⃣ Hide the note until the next cart update
  note.style.display = 'none';
  
  // 3️⃣ Re-run your existing gift logic → will treat those gifts as unseen
  if (typeof window.checkGiftsAndMaybeOpen === 'function') {
    giftLog('Re-running checkGiftsAndMaybeOpen from sidecart note');
    window.checkGiftsAndMaybeOpen();
  } else {
    giftWarn('checkGiftsAndMaybeOpen is not defined');
  }
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-gift-reswap');
  if (!btn) return;

  e.preventDefault();

  const lineKey = btn.dataset.lineKey;
  const handle  = btn.dataset.giftHandle;

  giftLog('Gift reswap clicked for line:', lineKey, 'handle:', handle);

  if (!lineKey) {
    giftWarn('Gift reswap: no lineKey present');
    return;
  }

  // 1️⃣ Remove this specific gift line from the cart
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: lineKey,
      quantity: 0
    })
  })
    .then(res => res.json())
    .then(cart => {
      giftLog('Gift line removed for reswap. Updated cart:', cart);

      // ✅ 2️⃣ Refresh the mini-cart / sidecart UI first

      // If you already have a standard cart-refresh function, use that:
      if (typeof window.updateCartContent === 'function') {
        giftLog('Reswap → calling updateCartContent()');
        try {
          window.updateCartContent(cart);
        } catch (e) {
          giftErr('Error in updateCartContent during reswap:', e);
        }
      } else {
        // Fallback: at least update the free gift note/banner
        if (typeof window.updateFreeGiftNote === 'function') {
          giftLog('Reswap → calling updateFreeGiftNote()');
          try {
            updateFreeGiftNote();
          } catch (e) {
            giftErr('Error in updateFreeGiftNote during reswap:', e);
          }
        }
      }

      // ❌ Do NOT resetSeenGifts here — reswap shouldn’t make it "unseen" again
      // if (typeof resetSeenGifts === 'function' && handle) {
      //   resetSeenGifts([handle]);
      // }

      // 3️⃣ Open THIS gift's quick view after the cart UI has been refreshed
      const gift = (window.FREE_GIFTS || []).find(g => g.handle === handle);
      if (gift && typeof window.openGiftQuickViewForUrl === 'function') {
        giftLog('Opening quick view directly for gift reswap →', gift.productUrl);

        // small delay so DOM refresh / sidecart animations can finish first
        setTimeout(() => {
          window.openGiftQuickViewForUrl(gift.productUrl, {
            onFinish: (how) => {
              giftLog('Reswap quick view finished for', handle, 'via:', how);
              if (how === 'added') {
                if (typeof window.updateFreeGiftNote === 'function') {
                  giftLog('Reswap → calling updateFreeGiftNote() after gift re-add');
                  try { updateFreeGiftNote(); } catch (e) { giftErr(e); }
                } else if (typeof window.updateCartContent === 'function') {
                  giftLog('Reswap → calling updateCartContent() after gift re-add');
                  try { window.updateCartContent(); } catch (e) { giftErr(e); }
                }
              }

              // No extra "seen" logic here – this gift is already marked seen
              // in the original flow, and we didn’t reset it for reswap.
              // If customer clicks "No, Thanks" here, cart is already correct,
              // so nothing more to do.
            }
          });
        }, 150);
      } else {
        giftWarn('Could not find FREE_GIFT entry for handle:', handle);
      }
    })
    .catch(err => {
      giftErr('Error during gift reswap:', err);
    });
});


